import { UiButton, UiButtonProps } from "./ui_button"
import { getUiMetrics } from "./ui_metrics"

// Presets carry common configuration; callers describe the action and only override what the
// surrounding layout actually requires. Keep rendering and interaction inside UiButton.
const BUTTON_PRESETS = {
    standard: { size: "medium", variant: "secondary" },
    compact: { size: "small", variant: "secondary" },
    primary: { size: "medium", variant: "primary" },
    confirm: { size: "medium", variant: "success" },
    danger: { size: "medium", variant: "danger" },
} as const

export interface ButtonConfig extends UiButtonProps {
    preset?: keyof typeof BUTTON_PRESETS
}

export const createButton = ({ preset = "standard", ...config }: ButtonConfig): UiButton => {
    const defaults = BUTTON_PRESETS[preset]
    return new UiButton({ ...defaults, ...config,
        size: config.size ?? (preset === "standard" && getUiMetrics().density === "compact" ? "small" : defaults.size),
        variant: config.variant ?? defaults.variant })
}

// Glyphs are supplied by callers; sizing and input behavior stay in UiButton.
export const createIconButton = ({ icon, ...config }: Omit<ButtonConfig, "label" | "iconOnly"> & { icon: string }): UiButton =>
    createButton({ ...config, label: icon, iconOnly: true })

export const createToggleButton = (config: ButtonConfig & { selected: boolean }): UiButton =>
    createButton(config)
